/* eslint-disable no-unused-expressions */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-lone-blocks */
import React, { useContext, useEffect, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  Card,
  Chip,
  FormControl,
  Grid,
  IconButton,
  MenuItem,
  OutlinedInput,
  Paper,
  Select,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
import SimpleBar from "simplebar-react";
import AddVariant from "../AddVariant/AddVariant";
import VariantTable from "../VariantTable/VariantTable";
import { db, storage } from "../../../../firebaseConfig";
import {
  getDownloadURL,
  ref,
  StorageErrorCode,
  uploadBytesResumable,
} from "firebase/storage";
import { v4 as uuidv4 } from "uuid";
import StoreStepperContext from "../../../../context/storeStepperContext";
import { useNavigate } from "react-router-dom";
import {
  arrayUnion,
  collection,
  doc,
  getDoc,
  getDocs,
  query,
  setDoc,
  updateDoc,
  where,
  orderBy,
} from "firebase/firestore";
import { toast } from "react-toastify";
import FileUploadNewVersion from "../../../../components/common/FileUploadNewVersion";
import { useSelector } from "react-redux";
import AddBrand from "./AddBrand";
// import Warning from "../../../../../assets/svg/warning.svg";
import { Delete as DeleteIcon } from "@mui/icons-material";

function NewCatalog() {
  const {
    storeformData,
    setStoreFormData,
    setSaveContinueBtn,
    checkForEdit,
    setCheckForEdit,
    productIdForEdit,
    setProductIdForEdit,
    addProductFromOverviewDocId,
    addProductFromOverview,
    setAddProductFromOverview,
    setAddProductFromOverviewDocId,
    addProductForMasterList,
    setAddProductForMasterList,
    productCatalog,
    setProductCatalog,
    brandReload,
    products,
    setProducts,
  } = useContext(StoreStepperContext);

  console.log("%cstoreformData", "color:red", storeformData);

  const user = useSelector((state) => state.auth.value);
  const [selectedFiles, setSelectedFiles] = useState(null);
  const [selectedValue, setSelectedValue] = useState([]);
  const [selectedProductDesignation, setSelectedProductDesignation] = useState(
    []
  );
  const [variants, setVariants] = useState([]);
  const [clearVariant, setClearVariant] = useState(false);
  const [brandToggal, setBrandToggal] = useState(false);
  const navigate = useNavigate();

  const [categories, setCategories] = useState([]);
  const [brands, setBrands] = useState([]);
  const [filteredBrands, setFilteredBrands] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState("");
  const [selectedBrand, setSelectedBrand] = useState("");
  const [copyItemFromSuggestion, setCopyItemFromSuggestion] = useState(false);
  const [productType, setProductType] = useState(false);

  const [allProducts, setAllProducts] = useState([]);
  const [parcelProductData, setParcelProductData] = useState([]);
  console.log("parcelProductData:132", parcelProductData);

  const [errors, setErrors] = useState({
    productName: "",
    productCategory: "",
    productPrice: "",
    productWeight: "",
    productStock: "",
    productDescription: "",
  });

  const updateProductById = async (ids, newData) => {
    try {
      if (!ids || ids.length === 0) {
        console.log("No IDs provided");
        return;
      }

      // Ensure ids is an array
      const idArray = Array.isArray(ids) ? ids : [ids];

      for (const id of idArray) {
        const masterListReff = collection(db, "productMasterList");
        const q = query(masterListReff, where("productId", "==", id));
        const masterListSnapshot = await getDocs(q);

        if (!masterListSnapshot.empty) {
          masterListSnapshot.forEach(async (docSnap) => {
            const docRef = doc(db, "productMasterList", docSnap.id);

            const payload = {
              productPrice: newData?.price || "",
              productWeight: newData?.weight || "",
              productStock: newData?.quantity || "",
            };

            // Update the document with the new data
            await updateDoc(docRef, payload);
          });
        } else {
          console.log(`No document found for productId: ${id}`);
        }
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };

  useEffect(() => {
    const totalQuantity = storeformData?.currentProduct?.parcelProducts?.reduce(
      (sum, product) => sum + Number(product?.quantity),
      0
    );
    const totalWeight = storeformData?.currentProduct?.parcelProducts?.reduce(
      (sum, product) => sum + Number(product?.weight),
      0
    );
    const totalPrice = storeformData?.currentProduct?.parcelProducts?.reduce(
      (sum, product) => sum + Number(product?.price),
      0
    );

    setStoreFormData((prev) => ({
      ...prev,
      currentProduct: {
        ...prev.currentProduct,
        quantity: totalQuantity ?? "",
        weight: totalWeight ?? "",
        price: totalPrice ?? "",
      },
    }));
  }, [storeformData?.currentProduct?.parcelProducts, setStoreFormData]);

  useEffect(() => {
    if (user?.role === "Superadmin") {
      setStoreFormData((prev) => ({
        ...prev, // Preserve existing values
        storeCurrency: "$",
        storeWeight: "Lb",
      }));
    }
  }, [user?.role, setStoreFormData]);

  // Validation function
  const validateFields = () => {
    const newErrors = {
      productName:
        storeformData.currentProduct.productType === false
          ? storeformData.currentProduct.productName.trim() !== ""
            ? ""
            : "Name is required."
          : "",
      parcelName:
        storeformData.currentProduct.productType === true
          ? storeformData.currentProduct.parcelName.trim() !== ""
            ? ""
            : "Parcel Name is required."
          : "",
      productCategory: storeformData.currentProduct.productCategory
        ? ""
        : "Category is required.",
      productPrice: storeformData.currentProduct.productPrice
        ? /^\d+(\.\d{1,2})?$/.test(storeformData.currentProduct.productPrice)
          ? ""
          : "Invalid price format."
        : "Price is required.",
      productWeight: storeformData.currentProduct.productWeight
        ? /^\d+(\.\d{1,2})?$/.test(storeformData.currentProduct.productWeight)
          ? ""
          : "Invalid weight format."
        : "Weight is required.",
      productStock: storeformData.currentProduct.productStock
        ? /^\d+$/.test(storeformData.currentProduct.productStock)
          ? ""
          : "Stock must be a valid number."
        : "Stock is required.",
      productDescription: storeformData.currentProduct.productDescription
        ? ""
        : "Description is required.",
    };

    setErrors(newErrors);

    // Check if all fields are valid
    return Object.values(newErrors).every((error) => error === "");
  };

  const handleSave = () => {
    if (validateFields()) {
      if (addProductForMasterList === true) {
        handleAddNewToMasterTableProduct();
      } else if (addProductFromOverview === true && checkForEdit === false) {
        handleAddNewProduct();
      } else if (addProductFromOverview === true && checkForEdit === true) {
        updateProduct();
      } else if (checkForEdit === true && productCatalog === true) {
        updateProductCatalog();
      } else {
        handleAddProduct();
      }
    } else {
      toast.error("Please fix the validation errors.");
    }
  };

  const toggleBrand = () => {
    setBrandToggal(!brandToggal);
  };

  useEffect(() => {
    const fetchMasterProducts = async () => {
      try {
        const masterListRef = collection(db, "productMasterList");
        const masterListSnapshot = await getDocs(masterListRef);

        const products = await Promise.all(
          masterListSnapshot.docs.map(async (doc) => {
            const data = doc.data();
            let updatedImageUrls = [];

            // Ensure productImage is processed as an array
            const imagePaths = Array.isArray(data.productImage)
              ? data.productImage
              : [data.productImage].filter(Boolean); // Wrap single image in an array

            if (imagePaths.length > 0) {
              try {
                updatedImageUrls = await Promise.all(
                  imagePaths.map(async (imagePath) => {
                    try {
                      const imageRef = ref(storage, imagePath);
                      return await getDownloadURL(imageRef);
                    } catch (error) {
                      console.error(
                        "Error fetching image URL for product:",
                        data.productName,
                        imagePath,
                        error
                      );
                      return imagePath; // Return the original path if URL fetching fails
                    }
                  })
                );
              } catch (error) {
                console.error("Error processing product images:", error);
              }
            }

            return {
              id: doc.id,
              ...data,
              productImage:
                updatedImageUrls.length > 0
                  ? updatedImageUrls
                  : data.productImage, // Update productImage with new URLs or retain original paths
            };
          })
        );

        setAllProducts(products);
      } catch (error) {
        console.error("Error fetching master product list:", error);
      }
    };

    fetchMasterProducts();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      // Fetch categories
      const categoryQuery = query(
        collection(db, "brandCategory"),
        orderBy("name", "asc")
      );
      const categorySnapshot = await getDocs(categoryQuery);
      const fetchedCategories = categorySnapshot.docs.map(
        (doc) => doc.data().name
      );
      setCategories(fetchedCategories);

      // Fetch brands
      const brandQuery = query(
        collection(db, "brands"),
        orderBy("brandName", "asc")
      );
      const brandSnapshot = await getDocs(brandQuery);
      const fetchedBrands = brandSnapshot.docs.map((doc) => ({
        brandName: doc.data().brandName,
        brandCategory: doc.data().brandCategory,
      }));

      setBrands(fetchedBrands);
    };

    fetchData();
  }, [brandReload]);

  useEffect(() => {
    // Filter brands based on the selected category
    if (selectedCategory) {
      const filtered = brands.filter(
        (brand) => brand.brandCategory === selectedCategory
      );
      setFilteredBrands(filtered);
    } else {
      setFilteredBrands([]);
    }
  }, [selectedCategory, brands]);

  useEffect(() => {
    if (productCatalog === true) {
      const producteditData = async () => {
        const masterListReff = collection(db, "productMasterList");
        const q = query(
          masterListReff,
          where("productId", "==", productIdForEdit)
        );
        const masterListSnapshott = await getDocs(q);

        let productObject = null;
        if (!masterListSnapshott.empty) {
          const doc = masterListSnapshott.docs[0];
          productObject = doc.data();
        }

        //  setProductData(productObject);

        if (productObject) {
          setStoreFormData((prev) => ({
            ...prev,
            currentProduct: {
              ...productObject,
              // storeID: storeData.storeID,
              storeImages: productObject.productImage,
            },
          }));
          setSelectedCategory(productObject?.productCategory);
          setSelectedValue(productObject.productTags || []);
          setSelectedProductDesignation(
            productObject?.productDesignation || []
          );
          setVariants(productObject.productVarient || []);
        } else {
          console.log("No product found with the given ID.");
        }
      };

      producteditData();
    }
  }, [productIdForEdit, setStoreFormData, productCatalog]);

  useEffect(() => {
    if (addProductFromOverview === true && addProductFromOverviewDocId) {
      (async () => {
        try {
          const storeRef = doc(db, "stores", addProductFromOverviewDocId);

          const storeSnapshot = await getDoc(storeRef);

          if (storeSnapshot.exists()) {
            const storeData = storeSnapshot.data();
            const productToEdit = storeData.products.find(
              (product) => product.productId === productIdForEdit
            );

            if (productToEdit) {
              setStoreFormData((prev) => ({
                ...prev,
                currentProduct: {
                  ...productToEdit,
                  storeID: storeData.storeID,
                  storeImages: storeData.storeImages,
                },
              }));
              setSelectedCategory(productToEdit?.productCategory);
              setSelectedValue(productToEdit.productTags || []);
              setSelectedProductDesignation(
                productToEdit?.productDesignation || []
              );
              setVariants(productToEdit.productVarient || []);
            } else {
              console.log("No product found with the given ID.");
            }
          } else {
            console.log("Store document does not exist.");
          }
        } catch (error) {
          console.error("Error fetching product: ", error);
        }
      })(); // Immediately invoke the async function
    } else if (checkForEdit && productIdForEdit) {
      const productToEdit = storeformData?.products?.find(
        (product) => product?.productId === productIdForEdit
      );

      if (productToEdit) {
        setStoreFormData((prev) => ({
          ...prev,
          currentProduct: { ...productToEdit },
        }));
        setSelectedCategory(productToEdit?.productCategory);
        setSelectedValue(productToEdit.productTags || []);
        setSelectedProductDesignation(productToEdit?.productDesignation || []);
        setVariants(productToEdit.productVarient || []);
      }
    } else {
      // Initialize `currentProduct` if not already set
      setStoreFormData((prev) => ({
        ...prev,
        currentProduct: prev.currentProduct || {
          productName: "",
          productCategory: "",
          productBrand: "",
          productPrice: "",
          productWeight: "",
          productStock: "",
          productDimentionL: "",
          productDimentionW: "",
          productDimentionH: "",
          productDescription: "",
          productTags: [],
          productImage: "",
          productVarient: [],
        },
      }));
    }
  }, [
    addProductFromOverview,
    addProductFromOverviewDocId,
    checkForEdit,
    productIdForEdit,
    setStoreFormData,
    storeformData.products,
  ]);

  const handleDelete = (chipToDelete) => {
    setSelectedValue((prevSelected) =>
      prevSelected.filter((name) => name !== chipToDelete)
    );
  };

  const [inputValue, setInputValue] = useState("");
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [selectedProduct, setSelectedProduct] = useState(null);

  const handleChangeFormData = (e) => {
    const { name, value } = e.target;
    if (name === "productCategory") {
      setSelectedCategory(value);
    }
    if (name === "productName") {
      setInputValue(value);

      // Filter products based on input
      if (value) {
        const filtered = allProducts?.filter((product) =>
          product?.productName?.toLowerCase()?.includes(value?.toLowerCase())
        );
        setFilteredProducts(filtered);
      } else {
        setFilteredProducts([]);
      }
    }
    setStoreFormData((prev) => ({
      ...prev,
      currentProduct: {
        ...prev.currentProduct,
        [name]: value,
      },
    }));
  };

  // productIdForEdit
  const updateProductCatalog = async () => {
    try {
      // Update the product in the Product Master List
      const masterListRef = doc(db, "productMasterList", productIdForEdit);
      await updateDoc(masterListRef, {
        ...storeformData.currentProduct,
      });

      toast.success("Product updated successfully!");
      setAddProductFromOverview(false);
      setAddProductFromOverviewDocId();
      setProductIdForEdit();
      setCheckForEdit(false);
      setProductCatalog(false);
      navigate("/shopping/add-products");
    } catch (error) {
      console.error("Error updating product:", error);
    }
  };

  const updateProduct = async () => {
    try {
      const storeRef = doc(db, "stores", addProductFromOverviewDocId);

      // Retrieve the current document
      const storeSnapshot = await getDoc(storeRef);

      if (storeSnapshot.exists()) {
        const storeData = storeSnapshot.data();

        // Find the existing products array
        const products = storeData.products || [];
        console.log(
          storeformData?.currentProduct?.productId,
          "products",
          products
        );

        // Update the specific product
        const updatedProducts = products.map((product) =>
          product.productId === storeformData?.currentProduct?.productId
            ? { ...product, ...storeformData?.currentProduct }
            : product
        );

        await updateDoc(storeRef, {
          products: updatedProducts,
        });

        // Update the product in the Product Master List
        const masterListRef = doc(
          db,
          "productMasterList",
          storeformData.currentProduct.productId
        );
        await updateDoc(masterListRef, {
          ...storeformData.currentProduct,
        });

        toast.success("Product updated successfully!");
        setAddProductFromOverview(false);
        setAddProductFromOverviewDocId();
        setProductIdForEdit();
        setCheckForEdit(false);
        navigate("/shopping/store");
      } else {
        console.log("Store document does not exist.");
      }
    } catch (error) {
      console.error("Error updating product:", error);
    }
  };

  const handleAddNewToMasterTableProduct = async () => {
    let newProduct;

    // Use the state updater to get the updated product with productId
    setStoreFormData((prev) => {
      newProduct = {
        ...prev.currentProduct,
        productId: uuidv4(),
        productStatus: user?.role === "Superadmin" ? true : false,
        productUnderReview: false,
      };
      return {
        ...prev,
        currentProduct: newProduct,
      };
    });

    try {
      const masterListRef = doc(db, "productMasterList", newProduct.productId);

      await setDoc(masterListRef, {
        ...newProduct,
      });
      toast.success("Product added successfully!");
      setAddProductForMasterList(false);
      setAddProductFromOverview(false);
      setAddProductFromOverviewDocId();
      setCopyItemFromSuggestion(false);
      setProductIdForEdit();
      setCheckForEdit(false);
      setStoreFormData((prev) => ({
        ...prev,
        currentProduct: prev.currentProduct || {
          productId: "",
          productName: "",
          productCategory: "",
          productBrand: "",
          productPrice: "",
          productWeight: "",
          productStock: "",
          productDimentionL: "",
          productDimentionW: "",
          productDimentionH: "",
          productDescription: "",
          productTags: [],
          productImage: "",
          productVarient: [],
          productStatus: user?.role === "Superadmin" ? true : false,
          productUnderReview: false,
        },
      }));
      navigate("/shopping/add-products");
    } catch (error) {
      console.error("Error adding product: ", error);
    }
  };

  const handleAddNewProduct = async () => {
    const storeRef = doc(db, "stores", addProductFromOverviewDocId);

    const storeSnapshot = await getDoc(storeRef);
    let newProduct;

    // Use the state updater to get the updated product with productId
    setStoreFormData((prev) => {
      newProduct = {
        ...prev.currentProduct,
        storeID: storeSnapshot.data().storeID,
        storeImages: storeSnapshot.data().storeImages,
        productId: uuidv4(),
        productStatus: user?.role === "Superadmin" ? true : false,
        productUnderReview: false,
      };
      return {
        ...prev,
        currentProduct: newProduct,
      };
    });
    try {
      const storeRef = doc(db, "stores", addProductFromOverviewDocId);
      const masterListRef = doc(db, "productMasterList", newProduct.productId);
      await updateDoc(storeRef, {
        products: arrayUnion(newProduct),
      });

      await setDoc(masterListRef, {
        ...newProduct,
      });
      toast.success("Product added successfully!");
      setAddProductFromOverview(false);
      setAddProductFromOverviewDocId();
      setCopyItemFromSuggestion(false);
      setProductIdForEdit();
      setCheckForEdit(false);
      setStoreFormData((prev) => ({
        ...prev,
        currentProduct: prev.currentProduct || {
          storeID: "",
          storeImages: [],
          productId: "",
          productName: "",
          productCategory: "",
          productBrand: "",
          productPrice: "",
          productWeight: "",
          productStock: "",
          productDimentionL: "",
          productDimentionW: "",
          productDimentionH: "",
          productDescription: "",
          productTags: [],
          productImage: "",
          productVarient: [],
          productStatus: user?.role === "Superadmin" ? true : false,
          productUnderReview: false,
        },
      }));
      navigate("/shopping/store");
    } catch (error) {
      console.error("Error adding product: ", error);
    }
  };

  const handleAddProduct = () => {
    const formattedVariants = variants.reduce((acc, variant) => {
      const variantObject = {
        [variant.variantName]: variant.variantValue,
      };
      acc.push(variantObject);
      return acc;
    }, []);

    const newProduct = {
      ...storeformData.currentProduct,
      productId: checkForEdit
        ? storeformData.currentProduct.productId // Retain the existing ID for editing
        : uuidv4(),
      productTags: selectedValue,
      productVarient: variants,
      productStatus: user?.role === "Superadmin" ? true : false,
      productUnderReview: false,
    };

    // const updatedProductss = checkForEdit
    //   ? storeformData?.products
    //     ? storeformData?.products.map((product) =>
    //         product?.productId === productIdForEdit ? newProduct : product
    //       )
    //     : []
    //   : [...(storeformData?.products || []), newProduct];

    const updatedProducts = checkForEdit
      ? storeformData?.products
        ? storeformData?.products.map((product) =>
            product?.productId === productIdForEdit ? newProduct : product
          )
        : []
      : [...products, newProduct];

    if (storeformData?.currentProduct?.parcelProducts) {
      storeformData.currentProduct.parcelProducts.forEach((item) => {
        updateProductById(item?.id, item);
      });
    }

    setProducts(updatedProducts);

    setStoreFormData((prev) => ({
      ...prev,
      products: updatedProducts,
      currentProduct: {
        productName: "",
        productCategory: "",
        productBrand: "",
        productPrice: "",
        productWeight: "",
        productStock: "",
        productDimentionL: "",
        productDimentionW: "",
        productDimentionH: "",
        productDescription: "",
        productTags: [],
        productImage: "",
        productVarient: [],
        productStatus: user?.role === "Superadmin" ? true : false,
        productUnderReview: false,
        productType: false,
        parcelName: "",
        parcelProducts: [],
        price: "",
        quantity: "",
        weight: "",
      },
    }));

    setSelectedValue([]);
    setSelectedProductDesignation([]);
    setVariants([]);
    setClearVariant(!clearVariant);
    setSelectedFiles(null);
    setSaveContinueBtn(true);
    setProductIdForEdit();
    setCheckForEdit(false);
    sessionStorage.setItem("stepperRedirectStep", "1");
    navigate("/shopping/store/add-store");
  };

  const uploadImage = async (file) => {
    try {
      // Create a storage reference for the file
      const storageRef = ref(storage, `/store_products/${file.name}`);

      // Upload the file and wait for the snapshot
      const uploadTask = uploadBytesResumable(storageRef, file);
      const snapshot = await uploadTask;

      // Get the downloadable URL
      const photoUrl = await getDownloadURL(snapshot.ref);

      // Return the URL for further processing
      return photoUrl;
    } catch (error) {
      console.error("Error uploading file:", error);
      return null; // Return null for failed uploads
    }
  };

  const onUploadChange = async (fileArray) => {
    setSelectedFiles(fileArray); // Update local state for selected files

    try {
      // Upload files and get URLs in the same order
      const uploadedUrls = await Promise.all(
        fileArray.map((file) => uploadImage(file))
      );

      // Filter out any null entries (failed uploads)
      const validUrls = uploadedUrls.filter((url) => url !== null);

      // Update Firebase and local state
      setStoreFormData((prev) => ({
        ...prev,
        currentProduct: {
          ...prev.currentProduct,
          productImage: checkForEdit
            ? [...(prev.currentProduct.productImage || []), ...validUrls] // Merge existing and new URLs
            : validUrls, // Replace with new URLs
        },
      }));
    } catch (error) {
      console.error("Error uploading files:", error);
    }
  };

  const handleChangeTags = (event, newValue) => {
    setSelectedValue(newValue);
    setStoreFormData((prev) => ({
      ...prev,
      currentProduct: {
        ...prev.currentProduct,
        productTags: newValue,
      },
    }));
  };

  const handleChangeDesignation = (event, newValue) => {
    if (newValue?.length <= 2) {
      setSelectedProductDesignation(newValue);
      setStoreFormData((prev) => ({
        ...prev,
        currentProduct: {
          ...prev.currentProduct,
          productDesignation: newValue,
        },
      }));
    }
  };

  const handleAddVariant = (newVariants) => {
    setVariants(newVariants);
    setStoreFormData((prev) => ({
      ...prev,
      currentProduct: {
        ...prev.currentProduct,
        productVarient: newVariants,
      },
    }));
  };

  function highlightText(text, searchTerm) {
    if (!searchTerm) return text;

    const parts = text.split(new RegExp(`(${searchTerm})`, "gi"));
    return parts.map((part, index) =>
      part.toLowerCase() === searchTerm.toLowerCase() ? (
        <span
          key={index}
          style={{
            backgroundColor: "yellow",
            fontWeight: "bold",
          }}
        >
          {part}
        </span>
      ) : (
        part
      )
    );
  }

  const handleEditParcelProduct = (id, field, value) => {
    setStoreFormData((prev) => {
      if (!prev?.currentProduct?.parcelProducts) {
        console.warn("Parcel products not found");
        return prev;
      }

      const updatedProducts = prev.currentProduct.parcelProducts.map(
        (product) =>
          product.id === id ? { ...product, [field]: value } : product
      );

      return {
        ...prev,
        currentProduct: {
          ...prev.currentProduct,
          parcelProducts: updatedProducts,
        },
      };
    });
  };

  const handleAddProducts = () => {
    if (!parcelProductData || parcelProductData.length === 0) {
      console.warn("No products to add.");
      return;
    }

    setStoreFormData((prev) => {
      const existingProducts = prev?.currentProduct?.parcelProducts || [];

      const newProductsForStore = parcelProductData.filter(
        (newPro) =>
          !existingProducts.some((existing) => existing.id === newPro.id)
      );

      if (newProductsForStore.length === 0) {
        console.warn("No new products added to Store. All exist already.");
        return prev;
      }

      setParcelProductData((prevParcel) =>
        prevParcel.filter(
          (parcelPro) =>
            !newProductsForStore.some((newPro) => newPro.id === parcelPro.id)
        )
      );

      return {
        ...prev,
        currentProduct: {
          ...prev.currentProduct,
          productName: "",
          parcelProducts: [
            ...existingProducts,
            ...newProductsForStore.map((pro) => ({
              id: pro?.productId || "",
              name: pro?.productName || "",
              quantity: pro?.productQuantity || "",
              weight: pro?.productWeight || "",
              price: pro?.productPrice || "",
            })),
          ],
        },
      };
    });
  };

  const handleDeleteParcelProduct = (id) => {
    setStoreFormData((prev) => {
      if (!prev?.currentProduct?.parcelProducts) {
        console.warn("Parcel products not found.");
        return prev;
      }

      const updatedProducts = prev.currentProduct.parcelProducts.filter(
        (product) => product.id !== id
      );

      return {
        ...prev,
        currentProduct: {
          ...prev.currentProduct,
          parcelProducts: updatedProducts,
        },
      };
    });
  };

  function reset(isType) {
    setStoreFormData((prev) => ({
      ...prev,
      currentProduct: {
        productType: isType,
        productId: storeformData?.currentProduct?.productId || "",
        parcelName: "",
        totalWeight: "",
        fullPrice: "",
        parcelPrice: "",
        parcelProducts: [],
        storeImages: [],
        productBrand: "",
        productCategory: "",
        productImage: "",
        productDescription: "",
        productDimentionH: 0,
        productDimentionL: 0,
        productDimentionW: 0,
        productName: "",
        productPrice: 0,
        productStock: 0,
        productWeight: 0,
        productVarient: [],
        productKeyFeatures: "",
        productUseCase: "",
        productBenefits: "",
        productNutritionalValue: "",
        productProductSpecifications: "",
        productTags: [],
        productDesignation: "",
        productStatus: user?.role === "Superadmin" ? true : false,
        productUnderReview: false,
      },
    }));
  }

  const updateParcelSize = (field, value, index, type) => {
    setStoreFormData((prev) => {
      const updatedParcelSize = [...(prev.currentProduct?.parcelSize || [])];

      if (!updatedParcelSize[index]) {
        updatedParcelSize[index] = { parcelType: type };
      }

      // Update the specified field
      updatedParcelSize[index][field] = value;

      return {
        ...prev,
        currentProduct: {
          ...prev.currentProduct,
          parcelSize: updatedParcelSize,
        },
      };
    });
  };

  return (
    <>
      <Box>
        <SimpleBar
          forceVisible="x"
          autoHide={true}
          style={{
            overflowX: "auto",
            maxHeight: "77vh",
          }}
          className="custom-scrollbar"
        >
          <Box
            sx={{
              width: "70%",
              padding: "20px",
              backgroundColor: "white",
            }}
          >
            {user?.role !== "Superadmin" && checkForEdit === false && (
              <Box
                sx={{
                  marginBottom: "24px",
                  height: "45px",
                  border: "1px solid rgba(242, 153, 74, 1)",
                  backgroundColor: "rgba(251, 222, 197, 1)",
                  display: "flex",
                  alignItems: "center",
                  paddingX: 2,
                  borderRadius: "4px",
                }}
              >
                {/* <img src={Warning} alt="warning" width="24px" height="24px" /> */}
                <Typography sx={{ fontSize: "14px", marginLeft: 1 }}>
                  This product is pending approval. Once it's approved, it will
                  be introduced as a new product.
                </Typography>
              </Box>
            )}

            {/* Peoduct type button  */}
            <Stack direction={"row"} gap={3}>
              <Grid item sx={{ marginBottom: "10px" }}>
                <Button
                  variant="outlined"
                  color="primary"
                  sx={{
                    marginRight: "10px",
                    backgroundColor: !storeformData?.currentProduct?.productType
                      ? "#481AA3"
                      : "white",
                    color: !storeformData?.currentProduct?.productType
                      ? "white"
                      : "#481AA3",
                    borderColor: "#481AA3",
                    "&:hover": {
                      backgroundColor: !storeformData?.currentProduct
                        ?.productType
                        ? "#481AA3"
                        : "lightgray",
                    },
                  }}
                  onClick={() => reset(false)}
                >
                  Single Product
                </Button>

                <Button
                  variant="outlined"
                  color="primary"
                  sx={{
                    backgroundColor: storeformData?.currentProduct?.productType
                      ? "#481AA3"
                      : "white",
                    color: storeformData?.currentProduct?.productType
                      ? "white"
                      : "#481AA3",
                    borderColor: "#481AA3",
                    "&:hover": {
                      backgroundColor: storeformData?.currentProduct
                        ?.productType
                        ? "#481AA3"
                        : "lightgray",
                    },
                  }}
                  onClick={() => reset(true)}
                >
                  Parcel Product
                </Button>
              </Grid>
            </Stack>

            {storeformData?.currentProduct?.productType && (
              <Stack direction={"row"} gap={3}>
                <Grid item>
                  <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                    Parcel Name<span style={{ color: "#FF5630" }}>*</span>
                  </Typography>
                  <FormControl
                    fullWidth
                    sx={{ mt: 1, minWidth: "61vw" }}
                    size="small"
                  >
                    <OutlinedInput
                      type="text"
                      sx={{ height: "35px" }}
                      placeholder="Enter Name"
                      name="parcelName"
                      value={storeformData?.currentProduct.parcelName || ""}
                      onChange={handleChangeFormData}
                      autoComplete="off"
                    />
                    {errors.parcelName && (
                      <Typography
                        sx={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.parcelName}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
              </Stack>
            )}

            {!storeformData?.currentProduct?.productType && (
              <Stack direction={"row"} gap={3}>
                <Grid item>
                  <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                    Name<span style={{ color: "#FF5630" }}>*</span>
                  </Typography>
                  <FormControl
                    fullWidth
                    sx={{ mt: 1, minWidth: "61vw" }}
                    size="small"
                  >
                    <OutlinedInput
                      type="text"
                      sx={{ height: "35px" }}
                      placeholder="Enter Name"
                      name="productName"
                      value={storeformData?.currentProduct?.productName || ""}
                      onChange={handleChangeFormData}
                      autoComplete="off"
                    />
                    {errors.productName && (
                      <Typography
                        sx={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.productName}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
              </Stack>
            )}
            {!storeformData?.currentProduct?.productType &&
              filteredProducts.length > 0 && (
                <Box
                  sx={{
                    mt: 1,
                    borderRadius: "8px",
                    backgroundColor: "white",
                    zIndex: 10,
                    position: "absolute",
                    width: "61vw",
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)",
                    paddingX: "6px",
                    paddingY: "15px",
                  }}
                >
                  {filteredProducts.map((product) => (
                    <Grid
                      container
                      key={product.productId}
                      alignItems="center"
                      sx={{
                        cursor: "pointer",
                        "&:hover": { backgroundColor: "#F0F0F0" },
                        p: 1,
                        borderRadius: "4px",
                      }}
                      onClick={() => {
                        setCopyItemFromSuggestion(true);
                        setStoreFormData((prev) => ({
                          ...prev,
                          currentProduct: {
                            productName: product?.productName || "",
                            productCategory: product?.productCategory || "",
                            productBrand: product?.productBrand || "",
                            productPrice: product?.productPrice || "",
                            productWeight: product?.productWeight || "",
                            productStock: product?.productStock || "",
                            productDimentionL: product?.productDimentionL || "",
                            productDimentionW: product?.productDimentionW || "",
                            productDimentionH: product?.productDimentionH || "",
                            productDescription:
                              product?.productDescription || "",
                            productTags: product?.productTags || [],
                            productImage: product?.productImage || [],
                            productVarient: product?.productVarient || [],
                            productUnderReview:
                              product?.productUnderReview || false,
                          },
                        }));
                        setSelectedCategory(product?.productCategory);
                        setVariants(product?.productVarient || []);
                        setSelectedValue(product?.productTags || []);
                        setSelectedProductDesignation(
                          product?.productDesignation || []
                        );
                        setFilteredProducts([]);
                      }}
                    >
                      <Grid item xs={1}>
                        <Box display="flex" alignItems="center">
                          {product?.productImage?.length > 0 ? (
                            <img
                              src={
                                product?.productImage?.length > 0
                                  ? product?.productImage[0]
                                  : product?.productImage
                              }
                              alt={product.productName}
                              style={{
                                width: "28px",
                                height: "28px",
                                borderRadius: "4px",
                                marginLeft: "20px",
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                width: "28px",
                                height: "28px",
                                marginLeft: "20px",
                                borderRadius: "4px",
                                backgroundColor: "#8770DE",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#fff",
                                fontSize: "16px",
                              }}
                            >
                              {product?.productName?.charAt(0).toUpperCase()}
                            </div>
                          )}
                        </Box>
                      </Grid>
                      <Grid item xs={3}>
                        <Box display="flex" alignItems="center">
                          <Typography sx={{ fontSize: "12px" }}>
                            {highlightText(
                              product.productName,
                              storeformData.currentProduct?.productName
                            )}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography sx={{ fontSize: "12px" }}>
                          {product.productId}
                        </Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography sx={{ fontSize: "12px" }}>
                          {product.productCategory}
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography sx={{ fontSize: "12px" }}>
                          {product.productPrice}
                        </Typography>
                      </Grid>
                    </Grid>
                  ))}
                </Box>
              )}

            {storeformData?.currentProduct?.productType && (
              <Stack direction={"row"} gap={3} sx={{ marginTop: "1rem" }}>
                <Grid item>
                  <Box
                    sx={{
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "flex-end",
                      gap: "10px",
                    }}
                  >
                    <FormControl
                      fullWidth
                      sx={{ mt: 1, minWidth: "53.5vw" }}
                      size="small"
                    >
                      <OutlinedInput
                        type="text"
                        sx={{ height: "35px" }}
                        placeholder="Search products to add..."
                        name="productName"
                        // value={storeformData.currentProduct?.productName || ""}
                        value={storeformData?.currentProduct.productName || ""}
                        onChange={handleChangeFormData}
                        autoComplete="off"
                      />
                    </FormControl>
                    {storeformData?.currentProduct?.productType && (
                      <Button
                        variant="contained"
                        color="primary"
                        onClick={handleAddProducts}
                        fullWidth
                        size="small"
                        sx={{ height: "35px" }}
                      >
                        Add Product
                      </Button>
                    )}
                  </Box>
                </Grid>
              </Stack>
            )}
            {storeformData?.currentProduct?.productType &&
              filteredProducts.length > 0 && (
                <Box
                  sx={{
                    mt: 1,
                    borderRadius: "8px",
                    backgroundColor: "white",
                    zIndex: 10,
                    position: "absolute",
                    width: "61vw",
                    boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.08)",
                    paddingX: "6px",
                    paddingY: "15px",
                  }}
                >
                  {filteredProducts.map((product) => (
                    <Grid
                      container
                      key={product.productId}
                      alignItems="center"
                      sx={{
                        cursor: "pointer",
                        "&:hover": { backgroundColor: "#F0F0F0" },
                        p: 1,
                        borderRadius: "4px",
                      }}
                      onClick={() => {
                        setCopyItemFromSuggestion(true);
                        setParcelProductData((prev) => [
                          ...prev,
                          {
                            productId: product?.id || "",
                            productName: product?.productName || "",
                            productQuantity: product?.productStock || "",
                            productWeight: product?.productWeight || "",
                            productPrice: product?.productPrice || "",
                          },
                        ]);
                        setSelectedCategory(product?.productCategory);
                        setVariants(product?.productVarient || []);
                        setSelectedValue(product?.productTags || []);
                        setSelectedProductDesignation(
                          product?.productDesignation || []
                        );
                        setFilteredProducts([]);
                      }}
                    >
                      <Grid item xs={1}>
                        <Box display="flex" alignItems="center">
                          {product?.productImage?.length > 0 ? (
                            <img
                              src={
                                product?.productImage?.length > 0
                                  ? product?.productImage[0]
                                  : product?.productImage
                              }
                              alt={product.productName}
                              style={{
                                width: "28px",
                                height: "28px",
                                borderRadius: "4px",
                                marginLeft: "20px",
                              }}
                            />
                          ) : (
                            <div
                              style={{
                                width: "28px",
                                height: "28px",
                                marginLeft: "20px",
                                borderRadius: "4px",
                                backgroundColor: "#8770DE",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                color: "#fff",
                                fontSize: "16px",
                              }}
                            >
                              {product?.productName?.charAt(0).toUpperCase()}
                            </div>
                          )}
                        </Box>
                      </Grid>
                      <Grid item xs={3}>
                        <Box display="flex" alignItems="center">
                          <Typography sx={{ fontSize: "12px" }}>
                            {highlightText(
                              product.productName,
                              storeformData.currentProduct?.productName
                            )}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography sx={{ fontSize: "12px" }}>
                          {product.productId}
                        </Typography>
                      </Grid>
                      <Grid item xs={3}>
                        <Typography sx={{ fontSize: "12px" }}>
                          {product.productCategory}
                        </Typography>
                      </Grid>
                      <Grid item xs={2}>
                        <Typography sx={{ fontSize: "12px" }}>
                          {product.productPrice}
                        </Typography>
                      </Grid>
                    </Grid>
                  ))}
                </Box>
              )}

            {storeformData?.currentProduct?.productType && (
              <Stack direction="row" sx={{ marginTop: "20px" }} gap={2}>
                <Card sx={{ width: "100%", paddingX: "10px", paddingY: "5px" }}>
                  <TableContainer
                    component={Paper}
                    sx={{
                      marginTop: "10px",
                      maxHeight: 400, // Set max height for scroll
                      overflowY: "auto", // Enable vertical scrolling
                      "&::-webkit-scrollbar": {
                        width: "6px",
                      },
                      "&::-webkit-scrollbar-thumb": {
                        backgroundColor: "#ccc",
                        borderRadius: "6px",
                      },
                      "&::-webkit-scrollbar-track": {
                        backgroundColor: "#f1f1f1",
                      },
                    }}
                  >
                    <Table stickyHeader>
                      {" "}
                      {/* Ensures the header stays fixed while scrolling */}
                      <TableHead>
                        <TableRow>
                          <TableCell>Product</TableCell>
                          <TableCell>Quantity</TableCell>
                          <TableCell>Weight</TableCell>
                          <TableCell>Price</TableCell>
                          <TableCell align="center">Actions</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {storeformData?.currentProduct?.parcelProducts
                          ?.length === 0 ? (
                          <TableRow>
                            <TableCell colSpan={5} align="center">
                              <Typography variant="body1" color="textSecondary">
                                No products added
                              </Typography>
                            </TableCell>
                          </TableRow>
                        ) : (
                          storeformData?.currentProduct?.parcelProducts?.map(
                            (product) => (
                              <TableRow key={product.id}>
                                <TableCell>{product.name}</TableCell>
                                <TableCell>
                                  <TextField
                                    type="number"
                                    value={product.quantity}
                                    onChange={(e) =>
                                      handleEditParcelProduct(
                                        product.id,
                                        "quantity",
                                        e.target.value
                                      )
                                    }
                                    size="small"
                                    variant="outlined"
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextField
                                    type="number"
                                    step="0.01"
                                    value={product.weight}
                                    onChange={(e) =>
                                      handleEditParcelProduct(
                                        product.id,
                                        "weight",
                                        e.target.value
                                      )
                                    }
                                    size="small"
                                    variant="outlined"
                                  />
                                </TableCell>
                                <TableCell>
                                  <TextField
                                    type="number"
                                    step="0.01"
                                    value={product.price}
                                    onChange={(e) =>
                                      handleEditParcelProduct(
                                        product.id,
                                        "price",
                                        e.target.value
                                      )
                                    }
                                    size="small"
                                    variant="outlined"
                                  />
                                </TableCell>
                                <TableCell align="center">
                                  <IconButton
                                    color="error"
                                    onClick={() =>
                                      handleDeleteParcelProduct(product.id)
                                    }
                                  >
                                    <DeleteIcon />
                                  </IconButton>
                                </TableCell>
                              </TableRow>
                            )
                          )
                        )}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </Card>
              </Stack>
            )}
            {storeformData?.currentProduct?.productType && (
              <Stack
                direction={"row"}
                gap={3}
                sx={{
                  marginTop: "10px",
                }}
              >
                <Grid container spacing={2}>
                  <Grid item xs={4}>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                      Total Weight (Auto-calculated)
                    </Typography>
                    <FormControl
                      fullWidth
                      sx={{ mt: 1, minWidth: "10vw" }}
                      size="small"
                    >
                      <OutlinedInput
                        disabled={true}
                        type="text"
                        sx={{ height: "35px" }}
                        placeholder="Total Weight"
                        name="totalWeight"
                        value={storeformData?.currentProduct.weight || ""}
                        onChange={handleChangeFormData}
                        autoComplete="off"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                      Full Price (Auto-calculated)
                    </Typography>
                    <FormControl
                      fullWidth
                      sx={{ mt: 1, minWidth: "10vw" }}
                      size="small"
                    >
                      <OutlinedInput
                        disabled={true}
                        type="text"
                        sx={{ height: "35px" }}
                        placeholder="Full Price"
                        name="fullPrice"
                        value={storeformData?.currentProduct.price || ""}
                        onChange={handleChangeFormData}
                        autoComplete="off"
                      />
                    </FormControl>
                  </Grid>
                  <Grid item xs={4}>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                      Parcel Price (Admin Editable)
                      {/* <span style={{ color: "#FF5630" }}>*</span> */}
                    </Typography>
                    <FormControl
                      fullWidth
                      sx={{ mt: 1, minWidth: "10vw" }}
                      size="small"
                    >
                      <OutlinedInput
                        disabled={true}
                        type="text"
                        sx={{ height: "35px" }}
                        placeholder="Parcel Price"
                        name="parcelPrice"
                        value={storeformData?.currentProduct.quantity || ""}
                        onChange={handleChangeFormData}
                        autoComplete="off"
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Stack>
            )}

            <Stack direction="row" sx={{ marginTop: "20px" }} gap={2}>
              <Grid item>
                <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                  Category<span style={{ color: "#FF5630" }}>*</span>
                </Typography>
                <FormControl fullWidth sx={{ mt: 1 }} size="small">
                  <Select
                    displayEmpty
                    sx={{ height: "35px", minWidth: "30vw" }}
                    name="productCategory"
                    value={storeformData?.currentProduct?.productCategory || ""}
                    onChange={handleChangeFormData}
                  >
                    <MenuItem value="" disabled>
                      Select
                    </MenuItem>
                    {categories.map((category, index) => (
                      <MenuItem key={index} value={category}>
                        {category}
                      </MenuItem>
                    ))}
                  </Select>
                  {errors.productCategory && (
                    <Typography
                      sx={{ color: "red", fontSize: "12px", marginTop: "4px" }}
                    >
                      {errors.productCategory}
                    </Typography>
                  )}
                </FormControl>
              </Grid>
              <Grid item>
                <Typography
                  sx={{
                    fontSize: "14px",
                    fontWeight: "500",
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  Brand{" "}
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => setBrandToggal(true)}
                    disabled={
                      storeformData.currentProduct?.productCategory === ""
                    }
                    sx={{
                      fontSize: "12px",
                      height: "20px",
                    }}
                  >
                    Add Brand
                  </Button>
                </Typography>
                <FormControl fullWidth sx={{ mt: 1 }} size="small">
                  <Select
                    displayEmpty
                    sx={{ height: "35px", minWidth: "30vw" }}
                    name="productBrand"
                    value={storeformData?.currentProduct?.productBrand || ""}
                    onChange={handleChangeFormData}
                  >
                    <MenuItem value="" disabled>
                      Select
                    </MenuItem>
                    {filteredBrands.map((brand, index) => (
                      <MenuItem key={index} value={brand.brandName}>
                        {brand.brandName}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Stack>

            <Box
              sx={{
                display: "flex",
                mt: "24px",
              }}
            >
              <FileUploadNewVersion
                name="images"
                onChange={onUploadChange}
                refresh={selectedFiles}
              />
            </Box>

            <Stack direction="row" sx={{ marginTop: "20px" }} gap={3}>
              <Grid container spacing={2}>
                <Grid item xs={4}>
                  <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                    Price ({storeformData?.storeCurrency})
                    <span style={{ color: "#FF5630" }}>*</span>
                  </Typography>
                  <FormControl fullWidth sx={{ mt: 1 }} size="small">
                    <OutlinedInput
                      type="text"
                      placeholder="Price"
                      sx={{ height: "35px" }}
                      name="productPrice"
                      value={storeformData?.currentProduct?.productPrice || ""}
                      onChange={handleChangeFormData}
                    />
                    {errors.productPrice && (
                      <Typography
                        sx={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.productPrice}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                    Weight ({storeformData?.storeWeight})
                    <span style={{ color: "#FF5630" }}>*</span>
                  </Typography>
                  <FormControl fullWidth sx={{ mt: 1 }} size="small">
                    <OutlinedInput
                      sx={{ height: "35px" }}
                      type="text"
                      name="productWeight"
                      placeholder="Weight"
                      value={storeformData?.currentProduct?.productWeight || ""}
                      onChange={handleChangeFormData}
                    />
                    {errors.productWeight && (
                      <Typography
                        sx={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.productWeight}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={4}>
                  <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                    Stock<span style={{ color: "#FF5630" }}>*</span>
                  </Typography>
                  <FormControl fullWidth sx={{ mt: 1 }} size="small">
                    <OutlinedInput
                      type="text"
                      sx={{ height: "35px" }}
                      placeholder="Stock"
                      name="productStock"
                      value={storeformData?.currentProduct?.productStock || ""}
                      onChange={handleChangeFormData}
                    />
                    {errors.productStock && (
                      <Typography
                        sx={{
                          color: "red",
                          fontSize: "12px",
                          marginTop: "4px",
                        }}
                      >
                        {errors.productStock}
                      </Typography>
                    )}
                  </FormControl>
                </Grid>
              </Grid>
            </Stack>

            {!storeformData?.currentProduct?.productType && (
              <Stack direction="row" sx={{ marginTop: "20px" }} gap={3}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                      Dimensions (cm)
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Box sx={{ marginRight: "6px" }}>L</Box>
                    <FormControl fullWidth size="small">
                      <OutlinedInput
                        sx={{ height: "35px" }}
                        type="text"
                        name="productDimentionL"
                        placeholder="Length"
                        value={
                          storeformData?.currentProduct?.productDimentionL || ""
                        }
                        onChange={handleChangeFormData}
                      />
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Box sx={{ marginRight: "6px" }}>W</Box>
                    <FormControl fullWidth size="small">
                      <OutlinedInput
                        type="text"
                        name="productDimentionW"
                        sx={{ height: "35px" }}
                        placeholder="Width"
                        value={
                          storeformData?.currentProduct?.productDimentionW || ""
                        }
                        onChange={handleChangeFormData}
                      />
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Box sx={{ marginRight: "6px" }}>H</Box>
                    <FormControl fullWidth size="small">
                      <OutlinedInput
                        type="text"
                        sx={{ height: "35px" }}
                        name="productDimentionH"
                        placeholder="Height"
                        value={
                          storeformData?.currentProduct?.productDimentionH || ""
                        }
                        onChange={handleChangeFormData}
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Stack>
            )}

            {storeformData?.currentProduct?.productType && (
              <Stack direction="row" sx={{ marginTop: "20px" }} gap={3}>
                <Grid container spacing={2}>
                  <Grid item xs={12}>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                      Dimensions (cm)
                    </Typography>
                  </Grid>
                  {/* Small */}
                  <Grid item xs={12}>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                      Small Box Size
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Box sx={{ marginRight: "6px" }}>L</Box>
                    <FormControl fullWidth size="small">
                      <OutlinedInput
                        sx={{ height: "35px" }}
                        type="text"
                        placeholder="Length"
                        name="parcelSdimentionL"
                        value={
                          storeformData?.currentProduct?.parcelSize?.[0]
                            ?.parcelSdimentionL || ""
                        }
                        onChange={(e) =>
                          updateParcelSize(
                            "parcelSdimentionL",
                            e.target.value,
                            0,
                            "small"
                          )
                        }
                      />
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Box sx={{ marginRight: "6px" }}>W</Box>
                    <FormControl fullWidth size="small">
                      <OutlinedInput
                        type="text"
                        sx={{ height: "35px" }}
                        placeholder="Width"
                        name="parcelSdimentionW"
                        value={
                          storeformData?.currentProduct?.parcelSize?.[0]
                            ?.parcelSdimentionH || ""
                        }
                        onChange={(e) =>
                          updateParcelSize(
                            "parcelSdimentionW",
                            e.target.value,
                            0,
                            "small"
                          )
                        }
                      />
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Box sx={{ marginRight: "6px" }}>H</Box>
                    <FormControl fullWidth size="small">
                      <OutlinedInput
                        type="text"
                        sx={{ height: "35px" }}
                        placeholder="Height"
                        name="parceSldimentionH"
                        value={
                          storeformData?.currentProduct?.parcelSize?.[0]
                            ?.parcelSdimentionH || ""
                        }
                        onChange={(e) =>
                          updateParcelSize(
                            "parcelSdimentionH",
                            e.target.value,
                            0,
                            "small"
                          )
                        }
                      />
                    </FormControl>
                  </Grid>
                  {/* 2 */}
                  <Grid item xs={12}>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                      Medium Box Size
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Box sx={{ marginRight: "6px" }}>L</Box>
                    <FormControl fullWidth size="small">
                      <OutlinedInput
                        sx={{ height: "35px" }}
                        type="text"
                        placeholder="Length"
                        name="parcelMdimentionL"
                        value={
                          storeformData?.currentProduct?.parcelSize?.[1]
                            ?.parcelMdimentionL || ""
                        }
                        onChange={(e) =>
                          updateParcelSize(
                            "parcelMdimentionL",
                            e.target.value,
                            1,
                            "medium"
                          )
                        }
                      />
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Box sx={{ marginRight: "6px" }}>W</Box>
                    <FormControl fullWidth size="small">
                      <OutlinedInput
                        type="text"
                        sx={{ height: "35px" }}
                        placeholder="Width"
                        name="parcelMdimentionW"
                        value={
                          storeformData?.currentProduct?.parcelSize?.[1]
                            ?.parcelMdimentionW || ""
                        }
                        onChange={(e) =>
                          updateParcelSize(
                            "parcelMdimentionW",
                            e.target.value,
                            1,
                            "medium"
                          )
                        }
                      />
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Box sx={{ marginRight: "6px" }}>H</Box>
                    <FormControl fullWidth size="small">
                      <OutlinedInput
                        type="text"
                        sx={{ height: "35px" }}
                        placeholder="Height"
                        name="parcelMdimentionH"
                        value={
                          storeformData?.currentProduct?.parcelSize?.[1]
                            ?.parcelMdimentionH || ""
                        }
                        onChange={(e) =>
                          updateParcelSize(
                            "parcelMdimentionH",
                            e.target.value,
                            1,
                            "medium"
                          )
                        }
                      />
                    </FormControl>
                  </Grid>
                  {/* 3 */}
                  <Grid item xs={12}>
                    <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                      Big Box Size
                    </Typography>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Box sx={{ marginRight: "6px" }}>L</Box>
                    <FormControl fullWidth size="small">
                      <OutlinedInput
                        sx={{ height: "35px" }}
                        type="text"
                        placeholder="Length"
                        name="parcelBdimentionL"
                        value={
                          storeformData?.currentProduct?.parcelSize?.[2]
                            ?.parcelBdimentionL || ""
                        }
                        onChange={(e) =>
                          updateParcelSize(
                            "parcelBdimentionL",
                            e.target.value,
                            2,
                            "big"
                          )
                        }
                      />
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Box sx={{ marginRight: "6px" }}>W</Box>
                    <FormControl fullWidth size="small">
                      <OutlinedInput
                        type="text"
                        sx={{ height: "35px" }}
                        placeholder="Width"
                        name="parcelBdimentionW"
                        value={
                          storeformData?.currentProduct?.parcelSize?.[2]
                            ?.parcelBdimentionW || ""
                        }
                        onChange={(e) =>
                          updateParcelSize(
                            "parcelBdimentionW",
                            e.target.value,
                            2,
                            "big"
                          )
                        }
                      />
                    </FormControl>
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sx={{ display: "flex", alignItems: "center" }}
                  >
                    <Box sx={{ marginRight: "6px" }}>H</Box>
                    <FormControl fullWidth size="small">
                      <OutlinedInput
                        type="text"
                        sx={{ height: "35px" }}
                        placeholder="Height"
                        name="parcelBdimentionH"
                        value={
                          storeformData?.currentProduct?.parcelSize?.[2]
                            ?.parcelBdimentionH || ""
                        }
                        onChange={(e) =>
                          updateParcelSize(
                            "parcelBdimentionH",
                            e.target.value,
                            2,
                            "big"
                          )
                        }
                      />
                    </FormControl>
                  </Grid>
                </Grid>
              </Stack>
            )}

            <Stack sx={{ marginTop: 2 }}>
              <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                Description<span style={{ color: "#FF5630" }}>*</span>
              </Typography>
              <FormControl fullWidth sx={{ mt: 1 }} size="small">
                <OutlinedInput
                  type="text"
                  name="productDescription"
                  multiline
                  minRows={5}
                  placeholder="Enter Description"
                  value={
                    storeformData?.currentProduct?.productDescription || ""
                  }
                  onChange={handleChangeFormData}
                />
                {errors.productDescription && (
                  <Typography
                    sx={{
                      color: "red",
                      fontSize: "12px",
                      marginTop: "4px",
                    }}
                  >
                    {errors.productDescription}
                  </Typography>
                )}
              </FormControl>
            </Stack>

            <Stack sx={{ marginTop: 2 }}>
              <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                Product Designation
              </Typography>
              <Autocomplete
                size="small"
                sx={{ height: "35px" }}
                multiple
                options={["Top picks today", "Top ship"]}
                freeSolo
                value={selectedProductDesignation}
                onChange={handleChangeDesignation}
                renderInput={(params) => (
                  <TextField
                    sx={{ height: "35px" }}
                    {...params}
                    placeholder="Search"
                    size="small"
                  />
                )}
                renderTags={() => null}
              />
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1,
                  marginTop: "8px",
                }}
              >
                {selectedProductDesignation?.map((tag, index) => (
                  <Chip
                    sx={{
                      backgroundColor: "rgba(238, 238, 238, 1)",
                      fontSize: "14px",
                      fontWeight: 500,
                      height: "28px",
                    }}
                    key={index}
                    label={tag}
                    onDelete={() => {
                      setSelectedProductDesignation((prev) =>
                        prev.filter((_, i) => i !== index)
                      );
                    }}
                  />
                ))}
              </Box>
            </Stack>

            <Stack sx={{ marginTop: 2, marginBottom: 2 }}>
              <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                Tags
              </Typography>
              <Autocomplete
                size="small"
                sx={{ height: "35px" }}
                multiple
                options={["Tags", "Tag choice 2", "Tag choice 3"]}
                freeSolo
                value={selectedValue}
                onChange={handleChangeTags}
                renderInput={(params) => (
                  <TextField
                    sx={{ height: "35px" }}
                    {...params}
                    placeholder="Search"
                    size="small"
                  />
                )}
                renderTags={() => null}
              />
              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 1,
                  marginTop: "8px",
                }}
              >
                {selectedValue?.map((tag, index) => (
                  <Chip
                    sx={{
                      backgroundColor: "rgba(238, 238, 238, 1)",
                      fontSize: "14px",
                      fontWeight: 500,
                      height: "28px",
                    }}
                    key={index}
                    label={tag}
                    onDelete={() => {
                      setSelectedValue((prev) =>
                        prev.filter((_, i) => i !== index)
                      );
                    }}
                  />
                ))}
              </Box>
            </Stack>

            <Stack sx={{ marginTop: 2 }}>
              <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                Key Features
              </Typography>
              <FormControl fullWidth sx={{ mt: 1 }} size="small">
                <OutlinedInput
                  type="text"
                  name="productKeyFeatures"
                  multiline
                  minRows={5}
                  placeholder="Enter Key Features"
                  value={
                    storeformData?.currentProduct?.productKeyFeatures || ""
                  }
                  onChange={handleChangeFormData}
                />
              </FormControl>
            </Stack>

            <Stack sx={{ marginTop: 2 }}>
              <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                Use Case
              </Typography>
              <FormControl fullWidth sx={{ mt: 1 }} size="small">
                <OutlinedInput
                  type="text"
                  name="productUseCase"
                  multiline
                  minRows={5}
                  placeholder="Enter Use Case"
                  value={storeformData?.currentProduct?.productUseCase || ""}
                  onChange={handleChangeFormData}
                />
              </FormControl>
            </Stack>

            <Stack sx={{ marginTop: 2 }}>
              <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                Benefits
              </Typography>
              <FormControl fullWidth sx={{ mt: 1 }} size="small">
                <OutlinedInput
                  type="text"
                  name="productBenefits"
                  multiline
                  minRows={5}
                  placeholder="Enter Benefits"
                  value={storeformData?.currentProduct?.productBenefits || ""}
                  onChange={handleChangeFormData}
                />
              </FormControl>
            </Stack>

            <Stack sx={{ marginTop: 2 }}>
              <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                Nutritional value
              </Typography>
              <FormControl fullWidth sx={{ mt: 1 }} size="small">
                <OutlinedInput
                  type="text"
                  name="productNutritionalValue"
                  multiline
                  minRows={5}
                  placeholder="Enter Nutritional value"
                  value={
                    storeformData?.currentProduct?.productNutritionalValue || ""
                  }
                  onChange={handleChangeFormData}
                />
              </FormControl>
            </Stack>

            <Stack sx={{ marginTop: 2 }}>
              <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                Product Specifications
              </Typography>
              <FormControl fullWidth sx={{ mt: 1 }} size="small">
                <OutlinedInput
                  type="text"
                  name="productProductSpecifications"
                  multiline
                  minRows={5}
                  placeholder="Enter Product Specifications"
                  value={
                    storeformData?.currentProduct
                      ?.productProductSpecifications || ""
                  }
                  onChange={handleChangeFormData}
                />
              </FormControl>
            </Stack>

            <Stack sx={{ marginTop: 2 }}>
              <Typography sx={{ fontSize: "14px", fontWeight: "500" }}>
                Target Audience
              </Typography>
              <FormControl fullWidth sx={{ mt: 1 }} size="small">
                <OutlinedInput
                  type="text"
                  name="productTagretAudience"
                  multiline
                  minRows={5}
                  placeholder="Enter Target Audience"
                  value={
                    storeformData?.currentProduct?.productTagretAudience || ""
                  }
                  onChange={handleChangeFormData}
                />
              </FormControl>
            </Stack>

            {!storeformData?.currentProduct?.productType && (
              <>
                <AddVariant
                  onAddVariant={handleAddVariant}
                  clearVariant={clearVariant}
                  whileEditVarinet={
                    storeformData?.currentProduct?.productVarient
                  }
                  copyItemFromSuggestion={copyItemFromSuggestion}
                />

                {variants.length > 0 && (
                  <VariantTable
                    variants={variants}
                    productDetails={storeformData?.currentProduct}
                  />
                )}
              </>
            )}
          </Box>
        </SimpleBar>
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            borderTop: "1px solid #E5E5E8",
          }}
        >
          <Box>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "white",
                color: "#1C2630",
                border: "1px solid #E5E5E8",
                minWidth: "126px",
                borderRadius: "4px",
                boxShadow: "none",
                whiteSpace: "nowrap",
                fontWeight: 600,
                marginTop: "20px",
                "&:hover": {
                  outline: "none",
                  color: "#1C2630",
                  backgroundColor: "white",
                },
              }}
              onClick={() => {
                setStoreFormData({
                  storeID: uuidv4(),
                  storeName: "",
                  storeLocation: "",
                  storeDescription: "",
                  storeShipment: "",
                  storeCreatedDate: new Date(),
                  products: [],
                });
                setStoreFormData((prev) => ({
                  ...prev,
                  productType: false,
                  parcelName: "",
                  totalWeight: "",
                  fullPrice: "",
                  parcelPrice: "",
                  parcelProducts: [],
                  storeImages: [],
                  productBrand: "",
                  productCategory: "",
                  productImage: "",
                  productDescription: "",
                  productDimentionH: 0,
                  productDimentionL: 0,
                  productDimentionW: 0,
                  productName: "",
                  productPrice: 0,
                  productStock: 0,
                  productWeight: 0,
                  productVarient: [],
                  productKeyFeatures: "",
                  productUseCase: "",
                  productBenefits: "",
                  productNutritionalValue: "",
                  productProductSpecifications: "",
                  productTags: [],
                  productDesignation: "",
                  productStatus: user?.role === "Superadmin" ? true : false,
                  productUnderReview: false,
                  price: "",
                  quantity: "",
                  weight: "",
                }));
                setCheckForEdit(false);
                setCopyItemFromSuggestion(false);
                setAddProductFromOverview(false);
                setProductIdForEdit();
                setAddProductFromOverviewDocId();
                {
                  checkForEdit === true && productCatalog === true
                    ? navigate("/shopping/add-products")
                    : navigate("/shopping/store");
                }
              }}
            >
              Cancel
            </Button>
          </Box>
          <Box>
            <Button
              variant="contained"
              onClick={handleSave}
              sx={{
                backgroundColor: "#5E17EB",
                color: "#fff",
                marginLeft: "20px",
                minWidth: "126px",
                border: "1px solid #E5E5E8",
                borderRadius: "4px",
                boxShadow: "none",
                whiteSpace: "nowrap",
                fontWeight: 600,
                marginTop: "20px",
                "&:hover": {
                  outline: "none",
                  color: "#fff",
                  backgroundColor: "#5E17EB",
                },
              }}
            >
              Save
            </Button>
          </Box>
        </Box>
      </Box>
      {brandToggal && (
        <AddBrand
          open={brandToggal}
          onClose={toggleBrand}
          productCategory={storeformData.currentProduct?.productCategory}
        />
      )}
    </>
  );
}

export default NewCatalog;
